import * as _ from "lodash";

import { IOrder } from "src/core/orders/api/orders.api";
import { IList } from "src/core/lists/api/lists.api";

const getCurrentQuantity = (
  productId: number,
  currentOrder: IOrder | IList | null
): number => {
  if (currentOrder) {
    const productOrderLine = _.find((currentOrder as IOrder).orderLines || (currentOrder as IList).listLines, orderLine => {
      return orderLine.productId === productId;
    });

    if (productOrderLine) {
      return productOrderLine.quantity;
    }
  }

  return 0;
};

export default getCurrentQuantity;
